import { FC } from 'react';
import { FONT_COLOURS } from '@belong/themes';
import { ListItem } from '../../styles/List/List';
import { Copy } from '../../styles/Typography/Copy';
import { ColumnLayout, IColumnLayout } from '../CountryList/CountryList.styles';
import { RegionContainer, RegionName } from './RegionalCountriesList.styles';

export interface IRegionalList extends Pick<IColumnLayout, 'hasColumns'> {
  regionName: string;
  countries: string[];
}

export const RegionalCountries: FC<IRegionalList> = ({ regionName, countries, hasColumns }) => {
  return (
    <RegionContainer>
      <RegionName isBold as="h3">
        {regionName}
      </RegionName>
      <ColumnLayout hasColumns={hasColumns}>
        {countries.map(country => (
          <ListItem key={country}>
            <Copy as="span" variant="small" hasColor={FONT_COLOURS.BASE}>
              {country}
            </Copy>
          </ListItem>
        ))}
      </ColumnLayout>
    </RegionContainer>
  );
};

RegionalCountries.displayName = 'RegionalCountries';
